import { Textarea } from "@/components/ui/textarea";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { FieldValues, UseFormReturn, Path } from "react-hook-form";
import { cn } from "@/lib/utils";

interface FormTextAreaProps<T extends FieldValues> {
  form: UseFormReturn<T>;
  label: string;
  id: Path<T>;
  description?: string;
  itemStyles?: string;
  className?: string;
  fieldName?: Path<T>;
  itemKey?: string;
  minRows?: number;
  hideLabel?: boolean;
  placeholder?: string;
}

export default function FormTextarea<T extends FieldValues>({
  form,
  label,
  id,
  description,
  className,
  itemStyles,
  fieldName,
  itemKey,
  minRows,
  hideLabel,
  placeholder,
}: FormTextAreaProps<T>) {
  return (
    <FormField
      key={itemKey}
      control={form.control}
      name={fieldName || id}
      render={({ field }) => (
        <FormItem className={itemStyles}>
          <FormLabel className={cn(hideLabel && "sr-only")}>{label}</FormLabel>
          <FormControl>
            <Textarea
              {...field}
              className={cn(
                "border-border text-primary-foreground",
                className,
              )}
              rows={minRows}
              placeholder={placeholder}
            />
          </FormControl>
          <FormDescription>{description}</FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
